import React from "react";
import { Outlet } from "react-router-dom";
import "./LayoutPage.css";
import SidebarPage from "../../SidebarPage/Sidebar";

const LayoutDesign = () => {
  return (
    <div className="layout-container">
      <SidebarPage className="sidebar" />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default LayoutDesign;
